<template>
    <div class="enterprise-qualification">
        <el-divider content-position="left">企业资质专题</el-divider>

        <enterprise-qualification-search @searchCompany="searchCompany" />

        <el-table :height="active_height" :span-method="objectSpanMethod" v-loading="loading" :data="tableData"
            style="width: 100%;margin-top: 0.2rem" border size="mini" :header-cell-style="{
                background: '#ecf4ff',
                color: '#333',
                fontWeight: '900',
                fontSize: '0.28rem'
            }" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.4)">
            <!-- <el-table-column prop="" label="" width="50">
                <template slot="header">
                    <el-checkbox v-model="table_choose_all[npage]" @change="handleChooseAllChange"></el-checkbox>
                </template>
<template slot-scope="scope">
                    <el-checkbox v-model="choose_edit[scope.row.id]"></el-checkbox>
                </template>
</el-table-column> -->
            <el-table-column prop="call_id" label="序号" width="80">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="company_name" label="公司名称" width="210">
                <template slot-scope="scope">
                    <el-link type="primary" class="count-style" @click="openInfoDrawer(scope.row)"
                        :title="scope.row.company_name">{{
                            scope.row.company_name }}</el-link>
                    <el-tooltip effect="dark" content="所在区域" placement="top">
                        <span>
                            {{ scope.row.base_info ?
                                `${scope.row.base_info.所属省份 ? scope.row.base_info.所属省份 + '-' : ''}${scope.row.base_info.所属城市
                                    ?
                                    scope.row.base_info.所属城市 + '-' : ''}${scope.row.base_info.所属区县 ? scope.row.base_info.所属区县 :
                            ''}`
                            : '' }}
                        </span>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="成立日期" placement="top">
                        <span>
                            {{ scope.row.base_info ? scope.row.base_info.成立日期 : '' }}
                        </span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="" label="企业状态" width="90">
                <template slot-scope="scope">
                    {{ scope.row.base_info ? scope.row.base_info.登记状态 : '-' }}
                </template>
            </el-table-column>
            <!-- <el-table-column class="enterpriseQualification" prop="" label="证书名称" width="150" max-width="">
                <template slot-scope="scope">
                    <!== <table class="field-table">
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <td>{{ i.info.证书名称 }}</td>
                            <!== <td>{{ i.info. }}</td>
                            <td>{{ i.certificate_no }}</td>
                            <td>{{ i.issuing_authority }}</td>
                            <td>{{ i.date_of_issue }}</td>
                            <td>{{ i.valid_to }}</td>
                            <td>{{ i.certificate_status }}</td> ==>
                        </tr>
                    </table> ==>
                    <div class="field-table" v-for="i in scope.row.enterpriseQualification" :key="i.id">
                        {{ i.info.证书名称 }}
                    </div>
                </template>
            </el-table-column> -->
            <el-table-column prop="qualification_certificate_info.证书名称" label="证书名称" width="150" max-width=""
                show-overflow-tooltip>
                <!-- <template slot-scope="scope">
                    <!== <table class="field-table">
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <td>{{ i.info.证书名称 }}</td>
                            <!== <td>{{ i.info. }}</td>
                            <td>{{ i.certificate_no }}</td>
                            <td>{{ i.issuing_authority }}</td>
                            <td>{{ i.date_of_issue }}</td>
                            <td>{{ i.valid_to }}</td>
                            <td>{{ i.certificate_status }}</td> ==>
                        </tr>
                    </table> ==>
                    <el-tag class="field-table" v-for="i in scope.row.enterpriseQualification" :key="i.id">
                        {{ i.info.证书名称 }}
                    </el-tag>
                </template> -->
            </el-table-column>
            <!-- <el-table-column class="enterpriseQualification" prop="" label="资质类别及等级/产品名称" width="210" max-width="">
                <template slot-scope="scope">
                    <!== <table class="field-table">
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <!== <td>{{ i.certificate_name }}</td> ==>
                            <td :title="i.info['资质类别及等级/产品名称']">{{ i.info['资质类别及等级/产品名称'] }}</td>
                            <!== <td>{{ i.certificate_no }}</td>
                            <td>{{ i.issuing_authority }}</td>
                            <td>{{ i.date_of_issue }}</td>
                            <td>{{ i.valid_to }}</td> ==>
                            <!== <td>{{ i.certificate_status }}</td> ==>
                        </tr>
                    </table> ==>
                    <div class="field-table" v-for="i in scope.row.enterpriseQualification" :key="i.id">
                        {{ i.info['资质类别及等级/产品名称'] }}
                    </div>
                </template>
            </el-table-column> -->
            <el-table-column prop="qualification_certificate_info.资质类别及等级/产品名称" label="资质类别及等级/产品名称" width=""
                max-width="" show-overflow-tooltip>
                <!-- <template slot-scope="scope">
                    <!== <table class="field-table">
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <!== <td>{{ i.certificate_name }}</td> ==>
                            <td :title="i.info['资质类别及等级/产品名称']">{{ i.info['资质类别及等级/产品名称'] }}</td>
                            <!== <td>{{ i.certificate_no }}</td>
                            <td>{{ i.issuing_authority }}</td>
                            <td>{{ i.date_of_issue }}</td>
                            <td>{{ i.valid_to }}</td> ==>
                            <!== <td>{{ i.certificate_status }}</td> ==>
                        </tr>
                    </table> ==>
                    <div class="field-table" v-for="i in scope.row.enterpriseQualification" :key="i.id">
                        {{ i.info['资质类别及等级/产品名称'] }}
                    </div>
                </template> -->
            </el-table-column>
            <!-- <el-table-column class="enterpriseQualification" prop="" label="证书编号" width="150" max-width="">
                <template slot-scope="scope">
                    <!== <table class="field-table">
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <!== <td>{{ i.certificate_name }}</td>
                            <td>{{ i.qualification_category_and_level_or_product_name }}</td> ==>
                            <td :title="i.info.证书编号">{{ i.info.证书编号 }}</td>
                            <!== <td>{{ i.issuing_authority }}</td>
                            <td>{{ i.date_of_issue }}</td>
                            <td>{{ i.valid_to }}</td>
                            <td>{{ i.certificate_status }}</td> ==>
                        </tr>
                    </table> ==>
                    <div :title="i.info.证书编号" class="field-table" v-for="i in scope.row.enterpriseQualification"
                        :key="i.id">
                        {{ i.info.证书编号 }}
                    </div>
                </template>
            </el-table-column> -->
            <el-table-column prop="qualification_certificate_info.证书编号" label="证书编号" width="150" max-width=""
                show-overflow-tooltip>
                <!-- <template slot-scope="scope">
                    <!== <table class="field-table">
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <!== <td>{{ i.certificate_name }}</td>
                            <td>{{ i.qualification_category_and_level_or_product_name }}</td> ==>
                            <td :title="i.info.证书编号">{{ i.info.证书编号 }}</td>
                            <!== <td>{{ i.issuing_authority }}</td>
                            <td>{{ i.date_of_issue }}</td>
                            <td>{{ i.valid_to }}</td>
                            <td>{{ i.certificate_status }}</td> ==>
                        </tr>
                    </table> ==>
                    <div :title="i.info.证书编号" class="field-table" v-for="i in scope.row.enterpriseQualification"
                        :key="i.id">
                        {{ i.info.证书编号 }}
                    </div>
                </template> -->
            </el-table-column>
            <!-- <el-table-column class="enterpriseQualification" prop="" label="发证机构" width="100" max-width="">
                <template slot-scope="scope">
                    <!== <table class="field-table">
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <!== <td>{{ i.certificate_name }}</td>
                            <td>{{ i.qualification_category_and_level_or_product_name }}</td>
                            <td>{{ i.certificate_no }}</td> ==>
                            <td :title="i.info.发证机构">{{ i.info.发证机构 }}</td>
                            <!== <td>{{ i.date_of_issue }}</td>
                            <td>{{ i.valid_to }}</td>
                            <td>{{ i.certificate_status }}</td> ==>
                        </tr>
                    </table> ==>
                    <div :title="i.info.发证机构" class="field-table" v-for="i in scope.row.enterpriseQualification"
                        :key="i.id">
                        {{ i.info.发证机构 }}
                    </div>
                </template>
            </el-table-column> -->
            <el-table-column prop="qualification_certificate_info.发证机构" label="发证机构" width="100" max-width=""
                show-overflow-tooltip>
                <!-- <template slot-scope="scope">
                    <!== <table class="field-table">
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <!== <td>{{ i.certificate_name }}</td>
                            <td>{{ i.qualification_category_and_level_or_product_name }}</td>
                            <td>{{ i.certificate_no }}</td> ==>
                            <td :title="i.info.发证机构">{{ i.info.发证机构 }}</td>
                            <!== <td>{{ i.date_of_issue }}</td>
                            <td>{{ i.valid_to }}</td>
                            <td>{{ i.certificate_status }}</td> ==>
                        </tr>
                    </table> ==>
                    <div :title="i.info.发证机构" class="field-table" v-for="i in scope.row.enterpriseQualification"
                        :key="i.id">
                        {{ i.info.发证机构 }}
                    </div>
                </template> -->
            </el-table-column>
            <!-- <el-table-column class="enterpriseQualification" prop="" label="发证日期" width="100" max-width="">
                <template slot-scope="scope">
                    <!== <table class="field-table">
                        <!== <tr style="background: #ecf4ff;
            color: #333;
            font-weight: 900">
                            <td>证书名称</td>
                            <td>资质类别及等级/产品名称</td>
                            <td>证书编号</td>
                            <td>发证机构</td>
                            <td>发证日期</td>
                            <td>有效期至</td>
                            <td>证书状态</td>
                        </tr> ==>
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <!== <td>{{ i.certificate_name }}</td>
                            <td>{{ i.qualification_category_and_level_or_product_name }}</td>
                            <td>{{ i.certificate_no }}</td>
                            <td>{{ i.issuing_authority }}</td> ==>
                            <td :title="i.info.发证日期">{{ i.info.发证日期 }}</td>
                            <!== <td>{{ i.valid_to }}</td>
                            <td>{{ i.certificate_status }}</td> ==>
                        </tr>
                    </table> ==>
                    <div :title="i.info.发证日期" class="field-table" v-for="i in scope.row.enterpriseQualification"
                        :key="i.id">
                        {{ i.info.发证日期 }}
                    </div>
                </template>
            </el-table-column> -->
            <el-table-column prop="qualification_certificate_info.发证日期" label="发证日期" width="100" max-width=""
                show-overflow-tooltip>
                <!-- <template slot-scope="scope">
                    <!== <table class="field-table">
                        <!== <tr style="background: #ecf4ff;
            color: #333;
            font-weight: 900">
                            <td>证书名称</td>
                            <td>资质类别及等级/产品名称</td>
                            <td>证书编号</td>
                            <td>发证机构</td>
                            <td>发证日期</td>
                            <td>有效期至</td>
                            <td>证书状态</td>
                        </tr> ==>
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <!== <td>{{ i.certificate_name }}</td>
                            <td>{{ i.qualification_category_and_level_or_product_name }}</td>
                            <td>{{ i.certificate_no }}</td>
                            <td>{{ i.issuing_authority }}</td> ==>
                            <td :title="i.info.发证日期">{{ i.info.发证日期 }}</td>
                            <!== <td>{{ i.valid_to }}</td>
                            <td>{{ i.certificate_status }}</td> ==>
                        </tr>
                    </table> ==>
                    <div :title="i.info.发证日期" class="field-table" v-for="i in scope.row.enterpriseQualification"
                        :key="i.id">
                        {{ i.info.发证日期 }}
                    </div>
                </template> -->
            </el-table-column>
            <!-- <el-table-column class="enterpriseQualification" prop="" label="有效期至" width="100" max-width="">
                <template slot-scope="scope">
                    <!== <table class="field-table">
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <!== <td>{{ i.certificate_name }}</td>
                            <td>{{ i.qualification_category_and_level_or_product_name }}</td>
                            <td>{{ i.certificate_no }}</td>
                            <td>{{ i.issuing_authority }}</td>
                            <td>{{ i.date_of_issue }}</td> ==>
                            <td :title="i.info.有效期至">{{ i.info.有效期至 }}</td>
                            <!== <td>{{ i.certificate_status }}</td> ==>
                        </tr>
                    </table> ==>
                    <div :title="i.info.有效期至" class="field-table" v-for="i in scope.row.enterpriseQualification"
                        :key="i.id">
                        {{ i.info.有效期至 }}
                    </div>
                </template>
            </el-table-column> -->
            <el-table-column prop="qualification_certificate_info.有效期至" label="有效期至" width="100" max-width=""
                show-overflow-tooltip>
                <!-- <template slot-scope="scope">
                    <!== <table class="field-table">
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <!== <td>{{ i.certificate_name }}</td>
                            <td>{{ i.qualification_category_and_level_or_product_name }}</td>
                            <td>{{ i.certificate_no }}</td>
                            <td>{{ i.issuing_authority }}</td>
                            <td>{{ i.date_of_issue }}</td> ==>
                            <td :title="i.info.有效期至">{{ i.info.有效期至 }}</td>
                            <!== <td>{{ i.certificate_status }}</td> ==>
                        </tr>
                    </table> ==>
                    <div :title="i.info.有效期至" class="field-table" v-for="i in scope.row.enterpriseQualification"
                        :key="i.id">
                        {{ i.info.有效期至 }}
                    </div>
                </template> -->
            </el-table-column>
            <!-- <el-table-column class="enterpriseQualification" prop="" label="证书状态" width="100" max-width="">
                <template slot-scope="scope">
                    <!== <table class="field-table">
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <!== <td>{{ i.certificate_name }}</td>
                            <td>{{ i.qualification_category_and_level_or_product_name }}</td>
                            <td>{{ i.certificate_no }}</td>
                            <td>{{ i.issuing_authority }}</td>
                            <td>{{ i.date_of_issue }}</td>
                            <td>{{ i.valid_to }}</td> ==>
                            <td>{{ i.info.证书状态 }}</td>
                        </tr>
                    </table> ==>
                    <div :title="i.info.证书状态" class="field-table" v-for="i in scope.row.enterpriseQualification"
                        :key="i.id">
                        {{ i.info.证书状态 }}
                    </div>
                </template>
            </el-table-column> -->
            <el-table-column prop="qualification_certificate_info.证书状态" label="证书状态" width="100" max-width=""
                show-overflow-tooltip>
                <!-- <template slot-scope="scope">
                    <!== <table class="field-table">
                        <tr v-for="i in scope.row.enterpriseQualification" :key="i.id">
                            <!== <td>{{ i.certificate_name }}</td>
                            <td>{{ i.qualification_category_and_level_or_product_name }}</td>
                            <td>{{ i.certificate_no }}</td>
                            <td>{{ i.issuing_authority }}</td>
                            <td>{{ i.date_of_issue }}</td>
                            <td>{{ i.valid_to }}</td> ==>
                            <td>{{ i.info.证书状态 }}</td>
                        </tr>
                    </table> ==>
                    <div :title="i.info.证书状态" class="field-table" v-for="i in scope.row.enterpriseQualification"
                        :key="i.id">
                        {{ i.info.证书状态 }}
                    </div>
                </template> -->
            </el-table-column>
            <el-table-column prop="" label="法定代表人" width="100" max-width="90">
                <template slot-scope="scope">
                    {{ scope.row.base_info ? scope.row.base_info.法定代表人 : '-' }}
                </template>
            </el-table-column>
            <el-table-column prop="" label="手机号" width="205">
                <template slot-scope="scope">
                    <div v-if="scope.row.phone && scope.row.phone.length === 1" class="phone-s-r">
                        <div class="phone-s">
                            <div class="phone-a-c">
                                <phone-com :comPhone="scope.row.phone[0].phone"
                                    :vagaryPhone="Object.hasOwnProperty.call(scope.row.phone[0], 'vagary_phone') ? scope.row.phone[0].vagary_phone : false"
                                    class="phone-com" />
                                <el-tooltip class="item" effect="dark" content="外呼" placement="top">
                                    <i @click="
                                        call(
                                            scope.row.phone[0].vagary_phone ? scope.row.phone[0].vagary_phone : scope.row.phone[0].phone
                                        )
                                        " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                                </el-tooltip>
                            </div>
                            <div>
                                <span>
                                    {{ scope.row.phone[0].province }} {{ scope.row.phone[0].city }}
                                </span>
                                <el-tag type="success" effect="dark" size="mini"
                                    v-if="scope.row.phone[0].weixinStatus && scope.row.phone[0].weixinStatus === '活跃号'">
                                    是微信
                                </el-tag>
                                <el-tag type="danger" effect="dark" size="mini"
                                    v-else-if="scope.row.phone[0].weixinStatus && scope.row.phone[0].weixinStatus !== '活跃号'">
                                    {{ scope.row.phone[0].weixinStatus }}
                                </el-tag>
                            </div>
                            <span>
                                手机号姓名: {{ scope.row.phone[0].name }}
                            </span>
                            <!-- <div>
                                <el-popover placement="bottom" width="300" trigger="click" :ref="`mp_${scope.row.id}`">
                                    <mark-position slot="content"/>
                                    <span slot="reference" class="pos-container" @click="showMarkPosition = scope.row.id">职位
                                        <el-tooltip effect="dark" content="点击标记职位,录入姓名" placement="top">
                                            <i class="el-icon-question pos-icon"></i>
                                        </el-tooltip>
                                    </span>
                                </el-popover>
                                <span style="margin-left: 0.2rem">:</span>
                            </div> -->
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                                v-if="scope.row.is_not_refreshed === 1">
                                <i class="el-icon-refresh r-icon r-icon-ref"
                                    @click="loadPhoneInformation(scope.row.id)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                    <div v-if="scope.row.phone && scope.row.phone.length > 1" class="phone-s-r">
                        <div class="phone-s">
                            <div class="phone-a-c">
                                <phone-com class="phone-com" :comPhone="scope.row.phone[0].phone"
                                    :vagaryPhone="Object.hasOwnProperty.call(scope.row.phone[0], 'vagary_phone') ? scope.row.phone[0].vagary_phone : false" />
                                <el-tooltip class="item" effect="dark" content="外呼" placement="top">
                                    <i @click="
                                        call(
                                            scope.row.phone[0].vagary_phone ? scope.row.phone[0].vagary_phone : scope.row.phone[0].phone
                                        )
                                        " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                                </el-tooltip>
                            </div>
                            <div>
                                <span>
                                    {{ scope.row.phone[0].province }} {{ scope.row.phone[0].city }}
                                </span>
                                <el-tag type="success" effect="dark" size="mini"
                                    v-if="scope.row.phone[0].weixinStatus && scope.row.phone[0].weixinStatus === '活跃号'">
                                    是微信
                                </el-tag>
                                <el-tag type="danger" effect="dark" size="mini"
                                    v-else-if="scope.row.phone[0].weixinStatus && scope.row.phone[0].weixinStatus !== '活跃号'">
                                    {{ scope.row.phone[0].weixinStatus }}
                                </el-tag>
                            </div>
                            <span>
                                手机号姓名: {{ scope.row.phone[0].name }}
                            </span>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                                v-if="scope.row.is_not_refreshed === 1">
                                <i class="el-icon-refresh r-icon r-icon-ref"
                                    @click="loadPhoneInformation(scope.row.id)"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="更多手机号" placement="top">
                                <i class="el-icon-more r-icon r-icon-more" @click="openMorePhone(scope.row.phone)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="" label="手机号（渠道拉取）" width="205">
                <template slot-scope="scope">
                    <div v-if="scope.row.xlb_phone && scope.row.xlb_phone.length === 1" class="phone-s-r">
                        <div class="phone-s">
                            <div class="phone-a-c">
                                <phone-com :comPhone="scope.row.xlb_phone[0].phone"
                                    :vagaryPhone="Object.hasOwnProperty.call(scope.row.xlb_phone[0], 'vagary_phone') ? scope.row.xlb_phone[0].vagary_phone : false"
                                    class="phone-com" />
                                <el-tooltip class="item" effect="dark" content="外呼" placement="top">
                                    <i @click="
                                        call(
                                            scope.row.xlb_phone[0].vagary_phone ? scope.row.xlb_phone[0].vagary_phone : scope.row.xlb_phone[0].phone
                                        )
                                        " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                                </el-tooltip>
                            </div>
                            <div>
                                <span>
                                    {{ scope.row.xlb_phone[0].province }} {{
                                        scope.row.xlb_phone[0].city }}
                                </span>
                                <el-tag type="success" effect="dark" size="mini"
                                    v-if="scope.row.xlb_phone[0].weixinStatus && scope.row.xlb_phone[0].weixinStatus === '活跃号'">
                                    是微信
                                </el-tag>
                                <el-tag type="danger" effect="dark" size="mini"
                                    v-else-if="scope.row.xlb_phone[0].weixinStatus && scope.row.xlb_phone[0].weixinStatus !== '活跃号'">
                                    {{ scope.row.xlb_phone[0].weixinStatus }}
                                </el-tag>
                            </div>
                            <span>
                                手机号姓名: {{ scope.row.xlb_phone[0].name }}
                            </span>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                                v-if="scope.row.is_not_refreshed === 1">
                                <i class="el-icon-refresh r-icon r-icon-ref"
                                    @click="loadPhoneInformation(scope.row.id)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                    <div v-if="scope.row.xlb_phone && scope.row.xlb_phone.length > 1" class="phone-s-r">
                        <div class="phone-s">
                            <div class="phone-a-c">
                                <phone-com class="phone-com" :comPhone="scope.row.xlb_phone[0].phone"
                                    :vagaryPhone="Object.hasOwnProperty.call(scope.row.xlb_phone[0], 'vagary_phone') ? scope.row.xlb_phone[0].vagary_phone : false" />
                                <el-tooltip class="item" effect="dark" content="外呼" placement="top">
                                    <i @click="
                                        call(
                                            scope.row.xlb_phone[0].vagary_phone ? scope.row.xlb_phone[0].vagary_phone : scope.row.xlb_phone[0].phone
                                        )
                                        " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                                </el-tooltip>
                            </div>
                            <div>
                                <span>
                                    {{ scope.row.xlb_phone[0].province }} {{
                                        scope.row.xlb_phone[0].city }}
                                </span>
                                <el-tag type="success" effect="dark" size="mini"
                                    v-if="scope.row.xlb_phone[0].weixinStatus && scope.row.xlb_phone[0].weixinStatus === '活跃号'">
                                    是微信
                                </el-tag>
                                <el-tag type="danger" effect="dark" size="mini"
                                    v-else-if="scope.row.xlb_phone[0].weixinStatus && scope.row.xlb_phone[0].weixinStatus !== '活跃号'">
                                    {{ scope.row.xlb_phone[0].weixinStatus }}
                                </el-tag>
                            </div>
                            <span>
                                手机号姓名: {{ scope.row.xlb_phone[0].name }}
                            </span>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                                v-if="scope.row.is_not_refreshed === 1">
                                <i class="el-icon-refresh r-icon r-icon-ref"
                                    @click="loadPhoneInformation(scope.row.id)"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="更多手机号" placement="top">
                                <i class="el-icon-more r-icon r-icon-more"
                                    @click="openMorePhone(scope.row.xlb_phone)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="" label="手机号（清洗后）" width="205">
                <template slot-scope="scope">
                    <div v-if="scope.row.self_phone && scope.row.self_phone.length === 1" class="phone-s-r">
                        <div class="phone-s">
                            <div class="phone-a-c">
                                <phone-com :comPhone="scope.row.self_phone[0].phone"
                                    :vagaryPhone="Object.hasOwnProperty.call(scope.row.self_phone[0], 'vagary_phone') ? scope.row.self_phone[0].vagary_phone : false"
                                    class="phone-com" />
                                <el-tooltip class="item" effect="dark" content="外呼" placement="top">
                                    <i @click="
                                        call(
                                            scope.row.self_phone[0].vagary_phone ? scope.row.self_phone[0].vagary_phone : scope.row.self_phone[0].phone
                                        )
                                        " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                                </el-tooltip>
                            </div>
                            <div>
                                <span>
                                    {{ scope.row.self_phone[0].province }} {{
                                        scope.row.self_phone[0].city }}
                                </span>
                                <el-tag type="success" effect="dark" size="mini"
                                    v-if="scope.row.self_phone[0].weixinStatus && scope.row.self_phone[0].weixinStatus === '活跃号'">
                                    是微信
                                </el-tag>
                                <el-tag type="danger" effect="dark" size="mini"
                                    v-else-if="scope.row.self_phone[0].weixinStatus && scope.row.self_phone[0].weixinStatus !== '活跃号'">
                                    {{ scope.row.self_phone[0].weixinStatus }}
                                </el-tag>
                            </div>
                            <span>
                                手机号姓名: {{ scope.row.self_phone[0].name }}
                            </span>
                            <span>
                                职位: {{ scope.row.self_phone[0].position.join('、') }}
                            </span>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                                v-if="scope.row.is_not_refreshed === 1">
                                <i class="el-icon-refresh r-icon r-icon-ref"
                                    @click="loadPhoneInformation(scope.row.id)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                    <div v-if="scope.row.self_phone && scope.row.self_phone.length > 1" class="phone-s-r">
                        <div class="phone-s">
                            <div class="phone-a-c">
                                <phone-com class="phone-com" :comPhone="scope.row.self_phone[0].phone"
                                    :vagaryPhone="Object.hasOwnProperty.call(scope.row.self_phone[0], 'vagary_phone') ? scope.row.self_phone[0].vagary_phone : false" />
                                <el-tooltip class="item" effect="dark" content="外呼" placement="top">
                                    <i @click="
                                        call(
                                            scope.row.self_phone[0].vagary_phone ? scope.row.self_phone[0].vagary_phone : scope.row.self_phone[0].phone
                                        )
                                        " class="el-icon-phone-outline" style="color: #409eff; cursor: pointer; margin-left: 0.1rem"></i>
                                </el-tooltip>
                            </div>
                            <div>
                                <span>
                                    {{ scope.row.self_phone[0].province }} {{
                                        scope.row.self_phone[0].city }}
                                </span>
                                <el-tag type="success" effect="dark" size="mini"
                                    v-if="scope.row.self_phone[0].weixinStatus && scope.row.self_phone[0].weixinStatus === '活跃号'">
                                    是微信
                                </el-tag>
                                <el-tag type="danger" effect="dark" size="mini"
                                    v-else-if="scope.row.self_phone[0].weixinStatus && scope.row.self_phone[0].weixinStatus !== '活跃号'">
                                    {{ scope.row.self_phone[0].weixinStatus }}
                                </el-tag>
                            </div>
                            <span>
                                手机号姓名: {{ scope.row.self_phone[0].name }}
                            </span>
                            <span>
                                职位: {{ scope.row.self_phone[0].position.join('、') }}
                            </span>
                        </div>
                        <div>
                            <el-tooltip class="item" effect="dark" content="刷新" placement="top"
                                v-if="scope.row.is_not_refreshed === 1">
                                <i class="el-icon-refresh r-icon r-icon-ref"
                                    @click="loadPhoneInformation(scope.row.id)"></i>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="更多手机号" placement="top">
                                <i class="el-icon-more r-icon r-icon-more"
                                    @click="openMorePhone(scope.row.self_phone)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="" label="座机号" width="145"> -->
            <!-- <template slot-scope="scope">
                    <div style="display: flex;align-items: center;justify-content: space-between;">
                        <div style="display:flex;flex-direction: column;"
                            v-if="scope.row.resource.more_phone && scope.row.resource.more_phone.length">
                            <span v-for="(item, index) in scope.row.resource.more_phone[0]" :key="index">{{ item
                                }}</span>
                        </div>
                        <div v-if="scope.row.resource.more_phone && scope.row.resource.more_phone.length >= 2"
                            style="text-align: center;">
                            <el-tooltip class="item" effect="dark" content="更多座机号" placement="top">
                                <i class="el-icon-more r-icon r-icon-more"
                                    @click="openMoreFixedPhone(scope.row.resource.more_phone)"></i>
                            </el-tooltip>
                        </div>
                    </div>
                </template> -->
            <!-- </el-table-column> -->
            <el-table-column prop="" label="会员/订单" width="110">
                <template slot-scope="scope">
                    <p>
                        是否会员:
                        <el-tag v-if="scope.row.user_id" type="success" size="mini" effect="dark">是</el-tag>
                        <el-tag v-else type="danger" size="mini" effect="dark">否</el-tag>
                    </p>
                    <p>
                        是否订单:
                        <el-tag v-if="scope.row.order_id" type="success" size="mini" effect="dark">是</el-tag>
                        <el-tag v-else type="danger" size="mini" effect="dark">否</el-tag>
                    </p>
                    <!-- <p>
                        是否会员:
                        <el-tag v-if="scope.row.resource.user_id" type="success" size="mini" effect="dark">是</el-tag>
                        <el-tag v-else type="danger" size="mini" effect="dark">否</el-tag>
                    </p>
                    <p>
                        是否订单:
                        <el-tag v-if="scope.row.resource.order_id" type="success" size="mini" effect="dark">是</el-tag>
                        <el-tag v-else type="danger" size="mini" effect="dark">否</el-tag>
                    </p> -->
                </template>
            </el-table-column>
        </el-table>

        <div style="text-align: right;">
            <pagination-com :total="total" :perPage="pageSize" :npage="npage" @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange" />
        </div>

        <el-drawer :visible.sync="infoDrawer" direction="rtl" :before-close="handleBeforeCloseInfoDrawer"
            @close="handleCloseInfoDrawer" size="50%" append-to-body>
            <template slot="title">
                <span style="color:#409eff;font-size:medium">{{ infoId }}</span>
            </template>
            <!-- <company-info style="padding: 0 0.2rem 0.2rem 0.2rem;" :call_task_id="infoId" /> -->
            <company-info-new style="padding: 0 0.2rem 0.2rem 0.2rem;" :companyName="infoId" />
        </el-drawer>

        <el-dialog :visible.sync="dialog" @closeDialog="closeDialog" @beforeCloseDialog="beforeCloseDialog"
            append-to-body width="40%" center>
            <template v-slot:title>
                <span class="dia-title">
                    更多手机号
                </span>
            </template>
            <div style="text-align: center;">
                <more-phone :options="leftPhone" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import PaginationCom from '../../commonReform/PaginationCom';
import CompanyInfo from '../cloudClue/Components/CompanyInfo';
import PhoneCom from "common/PhoneCom";
import MorePhone from '../cloudClue/Components/MorePhone';
import MoreFixed from '../cloudClue/Components/MoreFixed';
import EnterpriseQualificationSearch from './components/EnterpriseQualificationSearch';
import CompanyInfoNew from '../company_risks/common/CompanyInfo';
export default {
    name: 'EnterpriseQualification',
    components: { PaginationCom, CompanyInfo, PhoneCom, MorePhone, MoreFixed, EnterpriseQualificationSearch, CompanyInfoNew },
    data() {
        return {
            tableData: [],
            pageSize: 30,
            total: 0,
            npage: 1,
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/v1/"
                    : "https://qyh-next-server.zhang66.cn/v1/",
            searchArr: {
                company_id: '',
            },
            active_height: 'calc(100vh - 5rem)',
            table_choose_all: {},
            choose_edit: {},
            loading: true,
            infoId: null,
            infoDrawer: false,
            leftPhone: [],
            dialog: false,
        }
    },
    methods: {
        searchCompany(company_id) {
            this.searchArr.company_id = company_id
            this.loadTable()
        },
        doSearch(obj) {
            this.searchArr = { ...this.searchArr, ...obj }
            this.npage = 1
            this.loadTable()
        },
        loadTable() {
            this.loading = true
            // this.$axios.get(`/api/api3_call_task_resource_enterprise_qualification?page=${this.npage}`, {
            this.$axios.get(`${this.hyperfHost}api/call_task/call_task_resource_enterprise_qualification?page=${this.npage}`, {
                loadingClose: true,
                params: {
                    perPage: this.pageSize,
                    // cate: this.$route.params.cate,
                    // keyword: this.$route.params.keyword,
                    searchArr: this.searchArr,
                    // keyword: this.kw,
                    // manage: this.manageData
                },
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.loading = false
                    this.tableData = data.data.data
                    this.total = data.data.total
                }
            }).catch()
        },
        handleChooseAllChange(val) {
            if (val) {
                this.$set(this.table_choose_all, this.npage, true)
                this.tableData.map(item => {
                    this.$set(this.choose_edit, item.id, true)
                })
            } else {
                this.$set(this.table_choose_all, this.npage, false)
                this.tableData.map(item => {
                    this.$set(this.choose_edit, item.id, false)
                })
            }
        },
        handleSizeChange(val) {
            this.npage = 1;
            this.pageSize = val;
            this.loadTable();
        },
        handleCurrentChange(val) {
            this.npage = val;
            this.loadTable();
        },
        openInfoDrawer(row) {
            // this.infoId = row.call_id
            this.infoId = row.company_name
            this.infoDrawer = true
        },
        handleBeforeCloseInfoDrawer(done) {
            done();
        },
        handleCloseInfoDrawer() {
            this.infoId = null
        },
        call(phone) {
            if (!phone) {
                this.$message.error("手机号为空");
                return;
            }
            // this.$axios.post("/api/admin/call_logs/" + num).then((res) => {
            this.$axios
                .post("api/admin/call_logs_call", {
                    phone,
                })
                .then((res) => {
                    let { data } = res;
                    if (data.code === 0) {
                        this.$message.success("调用成功，请注意接听来电");
                        setTimeout(this.getCallLogs(this.order.customer_phone), 500);
                    } else {
                        this.$message.error(data.msg);
                    }
                });
        },
        openMorePhone(phone) {
            this.leftPhone = phone.slice(1);
            this.dialog = true
        },
        closeDialog() {
            this.leftPhone = []
        },
        beforeCloseDialog() {

        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            let arr = [0, 1, 2, 10, 11, 12, 13, 14, 15]
            if (arr.includes(columnIndex)) {
                if (rowIndex > 0 && this.tableData[rowIndex].company_name === this.tableData[rowIndex - 1].company_name) {
                    return [0, 0];
                }
                let i = rowIndex + 1;
                while (i < this.tableData.length && this.tableData[i].company_name === row.company_name) {
                    i++;
                }
                return [i - rowIndex, 1];
            }
        },
    },
    created() {
        this.loadTable()
        // this.$bus.$on('ysyTaskBaseSearch',(obj) => {
        //     this.doSearch(obj)
        // })
        // this.$bus.$on('ysyEnterpriseQualificationInfoSearch',(obj) => {
        //     this.doSearch(obj)
        // })
        this.$bus.$on('ysyEnterpriseQualificationDataFiltering', (obj) => {
            this.doSearch(obj)
        })
    },

    mounted() {
        // this.loadTable()
        // this.$bus.$on('ysyTaskBaseSearch',(obj) => {
        //     this.doSearch(obj)
        // })
        // this.$bus.$on('ysyEnterpriseQualificationInfoSearch',(obj) => {
        //     this.doSearch(obj)
        // })
        // this.$bus.$on('ysyEnterpriseQualificationDataFiltering',(obj) => {
        //     this.doSearch(obj)
        // })
    },
    computed: {
        // tableDataComputed() {
        //     let count = 1;
        //     for (let i = 0; i < this.tableData.length; i++) {
        //         if (i < this.tableData.length - 1 && this.tableData[i].call_id === this.tableData[i + 1].call_id) {
        //             count++;
        //         } else {
        //             this.tableData[i - count + 1].rowspan = count;
        //             count = 1;
        //         }
        //     }
        //     console.log(this.tableData, 'rowspan')
        //     return this.tableData
        // }
    },
    beforeDestroy() {
        this.$bus.$off('ysyTaskBaseSearch')
        this.$bus.$off('ysyEnterpriseQualificationInfoSearch')
    }
}
</script>

<style scoped>
.enterprise-qualification {
    padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

.enterprise-qualification .phone-s {
    display: flex;
    align-items: flex-start;
    /* justify-content: space-evenly; */
    justify-content: center;
    flex-direction: column;
}

.enterprise-qualification .phone-a-c {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: row;
}

.enterprise-qualification .phone-s-r {
    display: flex;
    align-items: center;
    /* justify-content: space-evenly; */
    justify-content: space-between;
    flex-direction: row;
    /* gap: 0.1rem; */
}

.enterprise-qualification .centered {
    /* 水平居中 */
    text-align: center;
    /* 垂直居中 */
    vertical-align: middle;
}



/* .field-table tr {
    background-color: none !important;
} */



/* .centered-count {
    text-align: right;
} */

.enterprise-qualification .dia-title {
    font-size: large;
    font-weight: bold;
    color: #409EFF;
}

.enterprise-qualification .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/pages/CallTaskResource/EnterpriseQualification.vue